var _templateObject, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import styled from '@emotion/styled';
import MUISvgIcon, { svgIconClasses } from '@mui/material/SvgIcon';
import * as React from "react";
var SvgIcon = styled(MUISvgIcon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.", " {\n    width: ", ";\n    height: ", ";\n    color: ", ";\n    stroke-width: 1px;\n    vector-effect: non-scaling-stroke;\n  }\n"])), svgIconClasses.root, function (_ref) {
  var size = _ref.size,
    theme = _ref.theme;
  return size && theme.size[size];
}, function (_ref2) {
  var size = _ref2.size,
    theme = _ref2.theme;
  return size && theme.size[size];
}, function (_ref3) {
  var color = _ref3.color,
    theme = _ref3.theme;
  return color && theme.color[color];
});
var SvgCoin = function SvgCoin(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffaf00",
    stroke: "#2c2b27",
    d: "M22.124 1.333C33.1 1.333 42 12.08 42 25.333s-8.9 24-19.876 24S2.25 38.59 2.25 25.336s8.9-24.003 19.874-24.003Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#d37047",
    d: "M22.124 5.833c8.906 0 16.126 8.732 16.126 19.5s-7.22 19.5-16.126 19.5S6 36.103 6 25.335 13.22 5.833 22.124 5.833Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2c2b27",
    d: "M24.737 12.583c.253 0 .422.303.34.59l-.229.805c-.054.194.004.41.142.523l7.016 5.61a.72.72 0 0 1 .244.56v6.924c0 .302-.163.567-.395.64l-8.908 2.887c-.152.049-.18.307-.043.404l4.998 3.627c.054.04.087.113.087.19v2.52c0 .125-.081.22-.175.22l-13.265-4.851c-.225-.082-.378-.34-.378-.636v-5.308c0-.285.144-.538.357-.627l5.182-2.186a.85.85 0 0 1 .593-.027l6.007 1.931c.224.009.295-.313.117-.413l-4.284-2.433-4.607-1.158-4.073-1.441a.38.38 0 0 1-.221-.238l-1.21-3.27a.53.53 0 0 1 .067-.496l.543-.693a.32.32 0 0 1 .218-.13l1.971-.223 5.52-3.089a.3.3 0 0 1 .132-.037l4.252-.168z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#d37047",
    stroke: "#2c2b27",
    d: "M45.66 27.452c.83-9.999-4.142-21.173-13.904-24.961a17.3 17.3 0 0 0-4.514-1.07c-1.195-.146-4.261-.06-5.492-.083 6.772-.059 12.903 4.195 16.306 9.868 2.592 4.22 3.869 9.19 3.866 14.128 0 4.902-1.256 9.833-3.81 14.034-3.395 5.716-9.55 10.019-16.362 9.96 1.219-.011 4.273.05 5.427-.076a17.4 17.4 0 0 0 4.646-1.102c8.318-3.243 13.259-12.079 13.835-20.698z"
  }))));
};
export default SvgCoin;